import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import logo from "../../../assets/media/logo.png";
import { resetPassword } from "../../../store/reducers/resetPasswordSlice";
import GBInput from "../../input";
import PasswordRequirementsHint from "../../common/PasswordRequirementsHint";
import { yupPassword } from "../../../helpers/passwordRules";

const Reset = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const passwordresetcode = queryParams.get("passwordresetcode");

  const loading = useSelector((state) => state.resetPassword.loading);
  const success = useSelector((state) => state.resetPassword.success);

  const initialValues = {
    password: "",
    new_password: "",
  };

  const validationSchema = Yup.object({
    password: yupPassword("New password"),
    new_password: Yup.string()
      .required("Re-enter your password")
      .oneOf([Yup.ref("password")], "Passwords do not match"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      dispatch(
        resetPassword({
          password: values.password,
          new_password: values.new_password,
          passwordresetcode: passwordresetcode,
        })
      );
    },
  });

  const { values, handleChange, handleSubmit, touched, errors } = formik;

  useEffect(() => {
    if (success) {
      navigate("/");
    }
  }, [success, navigate]);

  return (
    <div className="App">
      <div className="container">
        <div className="landingWrapper">
          <div className="lp-pwMain">
            <div className="lp-pwWrapper">
              <img src={logo} className="logo" alt="logo" />
              <h2>Reset Password</h2>
              <p>Create your new password to signin</p>

              <form className="gb-login-form" onSubmit={handleSubmit}>
                <div className="gb-field-wrap">
                  <label>New Password</label>
                  <GBInput
                    name="password"
                    className="form-class"
                    type="password"
                    placeholder=""
                    value={values.password}
                    setValue={handleChange}
                  />
                  {touched.password && errors.password && (
                    <div className="error-message">{errors.password}</div>
                  )}
                  <PasswordRequirementsHint />
                </div>
                <div className="gb-field-wrap">
                  <label>Re-Enter Password</label>
                  <GBInput
                    name="new_password"
                    className="form-class"
                    type="password"
                    placeholder=""
                    value={values.new_password}
                    setValue={handleChange}
                  />
                  {touched.new_password && errors.new_password && (
                    <div className="error-message">{errors.new_password}</div>
                  )}
                </div>
                <div className="gb-form-footer">
                  <button
                    type="submit"
                    disabled={loading}
                    className="form-submit"
                  >
                    {loading ? (
                      <>
                        <div
                          className="text-xs spinner-border text-light"
                          style={{ width: "1rem", height: "1rem" }}
                          role="status"
                        ></div>
                        <span className="sr-only ml-5"> Loading...</span>
                      </>
                    ) : (
                      "Reset Password"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reset;
